export const priveDataTransformer = (data:OmsOrderDataType) => ({
    totalRewardPointsToBeCredited:data.totalRewardPointsToBeCredited,
    priveTier: data.priveTier,
    multiplier: data.rewardMultiplier,
    multiplierDesc: data.rewardRuleDescription,
    baseRewardPoints: data.baseRewardPoints,
});

